import { render, staticRenderFns } from "./DisplayLabels.vue?vue&type=template&id=7b3a73ae&scoped=true&"
import script from "./DisplayLabels.vue?vue&type=script&lang=js&"
export * from "./DisplayLabels.vue?vue&type=script&lang=js&"
import style0 from "./DisplayLabels.vue?vue&type=style&index=0&id=7b3a73ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3a73ae",
  null
  
)

export default component.exports